import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps';
import React from 'react';

export const DefaultCouncilInitializer: React.FC<{
	placeId: string;
	setActiveViewport: React.Dispatch<React.SetStateAction<google.maps.LatLngBounds | null>>;
}> = ({ placeId, setActiveViewport }) => {
	const map = useMap();
	const placesLib = useMapsLibrary('places');

	React.useEffect(() => {
		if (!map || !placesLib || !placeId) return;

		let canceled = false;

		(async () => {
			try {
				// Using the new Places API
				const place = new placesLib.Place({ id: placeId });
				await place.fetchFields({
					fields: ['id', 'location', 'viewport'],
				});

				if (canceled) return;

				const viewport = place.viewport as google.maps.LatLngBounds | undefined;
				const location = place.location as google.maps.LatLng | undefined;

				if (viewport) {
					setActiveViewport(viewport);
				} else if (location) {
					map.panTo(place.location as google.maps.LatLng);
					map.setZoom(14);
				}
			} catch {
				// noop: if this fails we simply keep the default view
			}
		})();

		return () => {
			canceled = true;
		};
	}, [map, placesLib, placeId, setActiveViewport]);

	return null;
};
